import {
  TRAVEL_FETCHING,
  TRAVEL_FAILED,
  TRAVEL_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TRAVEL_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case TRAVEL_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case TRAVEL_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
